const cdnOssUrl = 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/'
export default{
  cdnOssUrl: cdnOssUrl
}
